import request from "../../service/request";
import constants from "../constants";
import paginationConstants from "../constants/pagination";
import { addQueryParamsToString, getKidExclusionRating } from "../utils";
const { APP_ENVIRONMENTS, API_BASE_URL } = constants;
const ENV = process.env.NODE_ENV || APP_ENVIRONMENTS.PROD;

const { INITIAL_START_INDEX, INITIAL_END_INDEX_VIEW_ALL } = paginationConstants;

function getSvodItems(
  appProvider,
  provider,
  subType,
  pcLevel = null,
  cancelTokenSource = null,
  userProfile = null,
  startIndex = INITIAL_START_INDEX,
  endIndex = INITIAL_END_INDEX_VIEW_ALL
) {
  const queryParams = {
    from: startIndex,
    to: endIndex,
    maxResults: endIndex + 1,
  };

  let url = appProvider.config.avs_api_urls.svod_package_items;
  url = url.replace("$TENANT_URL", appProvider.AGL_TENANT_URL);
  url = url.replace("$AGL_VERSION", appProvider.AGL_Version);
  url = url.replace("$USER_CLUSTER", appProvider.userCluster);
  url = url.replace("$LANG", appProvider.AVS_LANG);
  url = url.replace("$PLATFORM", appProvider.AVS_PLATFORM);
  url = url.replace("$PROPERTY", appProvider.AVS_PROPERTY);
  url = url.replace("$content_provider", provider);
  url = url.replace("$content_type", subType);

  if (appProvider.channelMapID) {
    queryParams.filter_regionId = appProvider.channelMapID;
  }

  if (appProvider.panicMode && appProvider.userCluster === "R") {
    queryParams.filter_technicalPackages = appProvider.svodPackageIds;
    queryParams.filter_pcLevel = appProvider.pcLevel;
  } else if (pcLevel) {
    queryParams.filter_pcLevel = pcLevel;
  }

  if (queryParams.filter_pcLevel) {
    getKidExclusionRating(userProfile, queryParams);
  }

  url = addQueryParamsToString(url, queryParams, true);

  if (ENV === APP_ENVIRONMENTS.DEV) {
    url = url.replace("https://" + appProvider.AGL_TENANT_URL, API_BASE_URL);
  }

  return request({ url: url, method: "GET" }, cancelTokenSource, appProvider);
}

export default getSvodItems;
